module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-content"
  }, [_c('div', {
    staticClass: "cls-content panel"
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入用户名（必填）"
    },
    model: {
      value: (_vm.ruleForm2.username),
      callback: function($$v) {
        _vm.ruleForm2.username = $$v
      },
      expression: "ruleForm2.username"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "icon iconfont icon-accountfilling"
  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "color": "#ffffff"
    },
    attrs: {
      "prop": "sex"
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("请选择性别：")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.ruleForm2.sex),
      callback: function($$v) {
        _vm.ruleForm2.sex = $$v
      },
      expression: "ruleForm2.sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入密码（必填）",
      "type": "password"
    },
    model: {
      value: (_vm.ruleForm2.password),
      callback: function($$v) {
        _vm.ruleForm2.password = $$v
      },
      expression: "ruleForm2.password"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "icon iconfont icon-password"
  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请确认密码（必填）",
      "type": "password"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.ruleForm2.checkPass = $$v
      },
      expression: "ruleForm2.checkPass"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "icon iconfont icon-password"
  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phoneNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.ruleForm2.phoneNumber),
      callback: function($$v) {
        _vm.ruleForm2.phoneNumber = $$v
      },
      expression: "ruleForm2.phoneNumber"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_c('i', {
    staticClass: "icon iconfont icon-mobilephone"
  })])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "qq"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入QQ号"
    },
    model: {
      value: (_vm.ruleForm2.qq),
      callback: function($$v) {
        _vm.ruleForm2.qq = $$v
      },
      expression: "ruleForm2.qq"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("QQ")])], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "birthday"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入生日: 19920422"
    },
    model: {
      value: (_vm.ruleForm2.birthday),
      callback: function($$v) {
        _vm.ruleForm2.birthday = $$v
      },
      expression: "ruleForm2.birthday"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("生日")])], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backToLogin
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d2f7562","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register.vue
// module id = 207
// module chunks = 1